import React, { useEffect, useState } from 'react'
import cls from './logo.module.scss'
import { classNames } from '@/shared/lib/utils/classNames'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import logo from '@/shared/assets/collectro.svg'
import { Link, useLocation } from 'react-router-dom'
import useResize from '@/shared/lib/hooks/useResize'

export const Logo = ({ className, color }) => {
    const location = useLocation()
    const windowWidth = useResize()

    const acnhorRender = (component) => {
        return (
            <AnchorLink
                style={{ textDecoration: 'none' }}
                href="#Home"
                offset={() => 100}
            >
                {component}
            </AnchorLink>
        )
    }

    const linkRender = (component) => {
        return (
            <Link
                style={{ textDecoration: 'none' }}
                to={'/'}
            >
                {component}
            </Link>
        )
    }
    const render = (component) => {
        if (location.pathname === '/') {
            return acnhorRender(component)
        } else {
            return linkRender(component)
        }
    }
    return render(
        <div className={classNames(cls.Logo, [className])}>
            <img
                className={cls.logo}
                src={logo}
                alt=""
            />

            <span
                className={cls.text}
                style={{ color: color }}
            >
                {windowWidth > 1160 ? 'Collectro' : ''}
            </span>
        </div>
    )
}
